export enum actionDetailsTypes {
	NO_CHANNELS = 'no_channels',
	ACCOUNT_VERIFICATION = 'account_verification',
	NO_CANCELLATION_PREFERENCE_SELECTED = 'no_cancellation_preference_selected',
	PHOTOSHOOT_OFFER = 'photoshoot_offer',
	ADD_PROPERTY = 'add_property',
	COMPLETE_PROPERTY = 'complete_property',
	PUBLISH_PROPERTY = 'publish_property',
	REPUBLISH_PROPERTY = 'republish_property',
	REFERRAL_PROGRAMME = 'referral_programme',
	DIRECT_HUB_AVAILABLE = 'direct_hub_available',
	SMART_PRICING_AVAILABLE = 'smart_pricing_available'
}
